// extracted by mini-css-extract-plugin
export default {"hr-desktop":"CollapsibleForm-module__hr-desktop__JHL_B","hr-mobile":"CollapsibleForm-module__hr-mobile__g8zAE","subtitle":"CollapsibleForm-module__subtitle__x0Sb8"};